module.exports = __webpack_public_path__ + "img/sint-eustatius.0370b29e.svg";